<template lang="pug">
  button.chat-widget(@click="toggle" :style="`background-color:#${primaryColor};`")
    .inner
      slot(name="default")
</template>

<script>

// eslint-disable-next-line no-unused-vars
const createWidget = (config) => {
  window.Papercups = {
    config
  }

  return new Promise((resolve,reject) => {
    if(document.querySelector('#PapercupsWidgetScript'))resolve();
    const scriptEl = document.createElement("script");

    scriptEl.id = "PapercupsWidgetScript";
    scriptEl.type = "text/javascript";
    scriptEl.async = true;
    scriptEl.defer = true;
    scriptEl.src =
        ("https:" === document.location.protocol ? "https://" : "http://") +
        "app.papercups.io/widget.js";

    scriptEl.addEventListener("load", () => resolve());
    scriptEl.addEventListener("error", (e) => reject(e));

    const s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(scriptEl, s);
  })
}

export default {
  name: "ChatWidget",
  props: {
    // important
    accountId: {
      type: String,
      required: true,
    },
    //
    title: {
      type: String,
      default: "touriDays-Support",
    },
    subtitle: {
      type: String,
      default: "Wir antworten in wenigen Stunden",
    },
    primaryColor: {
      type: String,
      default: "1a4e17",
    },
    greeting: String,
    newMessagePlaceholder: {
      type: String,
      default: "...",
    },
    baseUrl: {
      type: String,
      default: "https://app.papercups.io",
    },
    emailInputPlaceholder: {
      type: String,
      default: "Ihre E-Mail Addresse",
    },
    newMessagesNotificationText: {
      type: String,
      default: "Nachrichten Anzeigen",
    },
    showAgentAvailability: {
      type: Boolean,
      default: false,
    },
    agentAvailableText: {
      type: String,
      default: "We're online right now!",
    },
    agentUnavailableText: {
      type: String,
      default: "We're away at the moment.",
    },
    customer: {
      type: Object,
      default: () => ({
        name: undefined,
        email: undefined,
        external_id: undefined,
        metadata: undefined,
      }),
    },
    iframeUrlOverride: {
      type: String,
      default: "https://chat-widget.papercups.io",
    },
    requireEmailUpfront: {
      type: Boolean,
      default: false,
    },
    defaultIsOpen: {
      type: Boolean,
      default: false,
    },
    customIconUrl: {
      type: String,
      default: undefined,
    },
  },
  watch:{
    $route(){
      this.close();
    }
  },
  emits: [
    "chatLoaded",
    "chatOpened",
    "chatClosed",
    "messageSent",
    "messageReceived",
    "scriptLoaded",
    "scriptError",
  ],
  async setup(props, { emit }){
    const config = {
      ...props,
      onChatLoaded: () => emit("chatLoaded"),
      onChatOpened: () => emit("chatOpened"),
      onChatClosed: () => emit("chatClosed"),
      onMessageSent: () => emit("messageSent"),
      onMessageReceived: () => emit("messageReceived"),
    }
    return createWidget(config)
  },
  beforeUnmount(){
    this.close()
  },
  methods:{
    open() {
      window.dispatchEvent(new Event("papercups:open"));
    },
    close() {
      window.dispatchEvent(new Event("papercups:close"));
    },
    toggle() {
      window.dispatchEvent(new Event("papercups:toggle"));
    }
  }
}
</script>
<style scoped>
:global(#PapercupsChatWidget .Papercups-toggleButtonContainer){display:none!important;}
button.chat-widget{
  width:60px;
  height:60px;
  border-radius:50%;
  border:none;
  transition:all 0.5s;
  cursor:pointer;
  padding:0;
  margin:0;
}
button.chat-widget .inner{
  width:inherit;
  height:inherit;
  display:flex;
  align-items:center;
  justify-content:center;
}
</style>